import './CheckoutEntry';
import { SuccessRedirect } from 'components/SuccessRedirect';
import { Checkout } from 'containers/Checkout/Checkout';
import { useIdleTimer } from 'hooks/useIdleTimer';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { RedirectUrl } from 'utils';
import { AnalyticsHeap } from './components/AnalyticsHeap/AnalyticsHeap';
import { ErrorComponent } from './components/Error/Error';
import { store } from './store/configureStore';

import 'styles/main.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { idleTimeout } from 'utils/idleTimeout/idleTimeout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchOnReconnect: false,
    },
  },
});

function Router() {
  const isRedirecting = !!RedirectUrl.get();

  const { idle } = useIdleTimer({
    timeout: idleTimeout(),
  });

  if (idle) {
    window.xprops?.fwClose();
  }

  if (isRedirecting) {
    return <SuccessRedirect />;
  }

  return <Checkout onClose={window.xprops?.fwClose} />;
}

const container = document.getElementById('checkout-app-root');
const root = createRoot(container!);
root.render(
  <Provider store={store.configure()}>
    <AnalyticsHeap />
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary FallbackComponent={() => <ErrorComponent.Default />}>
        <Router />
      </ErrorBoundary>
    </QueryClientProvider>
  </Provider>,
);
